export default __webpack_public_path__ + "static/media/hexagon.6ec00ce4.svg";